import { render, staticRenderFns } from "./DownloadCard.vue?vue&type=template&id=98da1190&scoped=true&"
import script from "./DownloadCard.vue?vue&type=script&lang=js&"
export * from "./DownloadCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98da1190",
  null
  
)

export default component.exports